module.exports = __webpack_public_path__ + "static/media/mental-threats-large@2x.93c1ace9.png";